/*
 * @Author: etong
 * @Date: 2021-01-22 10:28:21
 * @LastEditTime: 2021-03-16 14:55:32
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\utils\permissionByMeta.js
 * Think first, Program later
 */
/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermissionByMeta(value, meta) {
  if (!meta || meta.length === 0) return false
  if (meta.length > 0) {
    for (let i = 0; i < meta.length; i++) {
      if (meta[i].controller_label === value) {
        return meta[i].use_limit_flag
      }
    }
  }
}
